import api from './api';

export const getEmployeeAppraisals = async (employeeId) => {
  try {
    const response = await api.get(`/appraisals/employee/${employeeId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching appraisals:', error);
    throw error;
  }
};

export const createAppraisal = async (appraisalData) => {
  try {
    const response = await api.post('/appraisals', appraisalData);
    return response.data;
  } catch (error) {
    console.error('Error creating appraisal:', error);
    throw error;
  }
};

export const updateAppraisal = async (id, appraisalData) => {
  try {
    const response = await api.put(`/appraisals/${id}`, appraisalData);
    return response.data;
  } catch (error) {
    console.error('Error updating appraisal:', error);
    throw error;
  }
};

export const getAppraisalTemplate = async () => {
  try {
    const response = await api.get('/appraisals/template');
    return response.data;
  } catch (error) {
    console.error('Error fetching appraisal template:', error);
    throw error;
  }
};
